import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-pencil",
  "use": "svg_i-pencil-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg_i-pencil\"><path d=\"m9.638 4.908-7.01 7.01H0V9.29l7.01-7.01 2.628 2.628zm2.075-2.074L10.34 4.208l-2.628-2.63L9.084.206a.698.698 0 0 1 .989 0l1.64 1.64a.698.698 0 0 1 0 .989z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol